import { render, staticRenderFns } from "./TeamAlbum.vue?vue&type=template&id=02b07873&scoped=true"
import script from "./TeamAlbum.vue?vue&type=script&lang=js"
export * from "./TeamAlbum.vue?vue&type=script&lang=js"
import style0 from "./TeamAlbum.vue?vue&type=style&index=0&id=02b07873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b07873",
  null
  
)

export default component.exports